export enum ENVIRONMENTS {
	development = 'development'
}

export enum HOSTS {
	developmentServer = 'developmentServer',
	testServer = 'testServer',
	productionServer = 'productionServer'
}

export enum SALON_TYPE {
	NON_BASIC = 'NON_BASIC',
	BASIC = 'BASIC'
}

export enum DAYS {
	MONDAY = 'MONDAY',
	TUESDAY = 'TUESDAY',
	WEDNESDAY = 'WEDNESDAY',
	THURSDAY = 'THURSDAY',
	FRIDAY = 'FRIDAY',
	SATURDAY = 'SATURDAY',
	SUNDAY = 'SUNDAY'
}

export enum OPENING_HOURS_STATUS {
	ALL = 'ALL',
	OPEN = 'OPEN',
	CLOSED = 'CLOSED'
}

const COORDINATES = {
	PRAGUE: {
		lat: 50.08505813401708,
		lng: 14.419970052817515
	},
	BRATISLAVA: {
		lat: 48.152711345286555,
		lng: 17.110079398988983
	},
	BUCHAREST: {
		lat: 44.426765,
		lng: 26.102537
	},
	SOFIA: {
		lat: 42.697708,
		lng: 23.324272
	},
	BUDAPEST: {
		lat: 47.497912,
		lng: 19.040235
	}
}

export const MAP = {
	defaultZoom: 15,
	minLatitude: -90,
	maxLatitude: 90,
	minLongitude: -180,
	maxLongitude: 180,
	minZoom: 9,
	maxZoom: 25,
	placeZoom: 16,
	defaultLocation: COORDINATES.PRAGUE,
	locations: {
		cs: COORDINATES.PRAGUE,
		sk: COORDINATES.BRATISLAVA,
		bg: COORDINATES.SOFIA,
		hu: COORDINATES.BUDAPEST,
		ro: COORDINATES.BUCHAREST
	}
}

export enum SORTING_OPTION {
	RECOMMENDED = 'RECOMMENDED',
	CLOSEST = 'CLOSEST',
	BEST_RATED = 'BEST_RATED',
	CHEAPEST = 'CHEAPEST',
	MOST_EXPENSIVE = 'MOST_EXPENSIVE'
}

export enum OPEN_HOURS_STATE {
	CUSTOM_ORDER = 'CUSTOM_ORDER'
}

export enum SEARCH_FIELD_OPTION_TYPE {
	SALON = 'SALON',
	CITY = 'CITY'
}

export enum PAYMENT_METHOD {
	CARD = 'Card',
	CASH = 'Cash'
}

export const SALONS_SEARCH_DEBOUNCE_TIME_MS = 400
export const SALONS_MAP_DEBOUNCE_TIME_MS = 400
export const COSMETICS_SEARCH_DEBOUNCE_TIME_MS = 400
export const FILTER_COUNTS_CHANGE_DEBOUNCE_TIME_MS = 300
export const CALENDAR_VIEW_CHANGE_DEBOUNCE_TIME_MS = 300

export const GA_EVENTS_DELAY = 100

export enum SALONS_FILTER_TYPE {
	PRICE = 'PRICE',
	AVAILABLE_RS = 'AVAILABLE_RS',
	// NOTE: gift filter temporary commented out https://goodrequest.atlassian.net/browse/NOT-16945
	// HAS_GIFT = 'HAS_GIFT',
	OPENING_HOURS = 'OPENING_HOURS',
	RATING = 'RATING',
	COSMETICS = 'COSMETICS',
	DATE = 'DATE',
	LANGUAGES = 'LANGUAGES',
	SORTING = 'SORTING'
}

export enum RATINGS {
	ONE = 1,
	TWO = 2,
	THREE = 3,
	FOUR = 4,
	FIVE = 5
}

export enum AVAILABLE_RESERVATION_TYPE {
	PHONE_RESERVATION = 'PHONE_RESERVATION',
	ONLINE_RESERVATION = 'ONLINE_RESERVATION'
}

export enum RESERVATIONS_TIME_SLOTS {
	ANY = 'ANY',
	MORNING = 'MORNING',
	AFTERNOON = 'AFTERNOON',
	EVENING = 'EVENING'
}

export const DEFAULT_DATE_FORMAT = 'YYYY-MM-DD'
export const DATE_FORMAT = 'DD.MM.YYYY'
export const DEFAULT_TIME_FORMAT = 'HH:mm'
export const DAY_NAME_DATE_FORMAT = 'dd, D.MMM'
export const DAY_NAME_DATE_YEAR_FORMAT = 'dd, D. MMM YY'
export const YEAR_MONTH_FORMAT = 'YYYY-MM'
export const FULL_MONTH_NAME = 'MMMM'
export const ICS_DATE_FORMAT = 'YYYYMMDDTHHmmss[Z]'

export const ARRAY_QUERY_PARAM_MAX_LENGTH = 50

export enum FORM {
	FILTER_SIDEBAR = 'FILTER_SIDEBAR',
	FILTER_SIDEBAR_PRICE = 'FILTER_SIDEBAR_PRICE',
	FILTER_SIDEBAR_EXACT_RATING = 'FILTER_SIDEBAR_EXACT_RATING',
	FILTER_SIDEBAR_COSMETICS = 'FILTER_SIDEBAR_COSMETICS',
	FILTER_SIDEBAR_LANGUAGES = 'FILTER_SIDEBAR_LANGUAGES',
	FILTER_SIDEBAR_DATE = 'FILTER_SIDEBAR_DATE',
	FILTER_SIDEBAR_ORDER_BY = 'FILTER_SIDEBAR_ORDER_BY',
	BOOKING_FORM = 'BOOKING_FORM',
	RESERVATION_BOOKING_MODAL_SERVICE_PARAMETER_SELECTION = 'RESERVATION_BOOKING_MODAL_SERVICE_PARAMETER_SELECTION',
	RESERVATION_BOOKING_MODAL_EMPLOYEE_AND_DATE_SELECTION = 'RESERVATION_BOOKING_MODAL_EMPLOYEE_AND_DATE_SELECTION',
	RESERVATION_BOOKING_MODAL_EMPLOYEE_AND_DATE_GROUP_SELECTION = 'RESERVATION_BOOKING_MODAL_EMPLOYEE_AND_DATE_GROUP_SELECTION',
	RESERVATION_BOOKING_MODAL_RESERVATIONS_SUMMARY = 'RESERVATION_BOOKING_MODAL_RESERVATIONS_SUMMARY',
	RESERVATION_BOOKING_MODAL_BOOKING_CONFIRMATION = 'RESERVATION_BOOKING_MODAL_BOOKING_CONFIRMATION'
}

export enum SELECT_OPTION_CLASS_NAME {
	BOTTOM_DIVIDER = 'select-option-with-bottom-divider'
}

export enum EVENT_TYPE {
	RESERVATION = 'RESERVATION',
	RESERVATION_FROM_IMPORT = 'RESERVATION_FROM_IMPORT',
	EMPLOYEE_SHIFT = 'EMPLOYEE_SHIFT',
	EMPLOYEE_TIME_OFF = 'EMPLOYEE_TIME_OFF',
	EMPLOYEE_BREAK = 'EMPLOYEE_BREAK',
	GROUP_RESERVATION = 'GROUP_RESERVATION'
}

export enum RESERVATION_BOOKING_MODAL_STEP {
	SERVICE_SELECTION = 'SERVICE_SELECTION',
	SERVICE_PARAMETER_SELECTION = 'SERVICE_PARAMETER_SELECTION',
	EMPLOYEE_AND_DATE_SELECTION = 'EMPLOYEE_AND_DATE_SELECTION',
	EMPLOYEE_AND_DATE_GROUP_SELECTION = 'EMPLOYEE_AND_DATE_GROUP_SELECTION',
	BOOKING_CONFIRMATION = 'BOOKING_CONFIRMATION',
	RESERVATIONS_SUMMARY = 'RESERVATIONS_SUMMARY',
	SUMMARY = 'SUMMARY'
}

export const APP_CONTAINER_ID = 'NOTINO_SALONS_PAGE_APP_CONTAINER'

export enum DOCUMENTS {
	B2C_PRIVACY_POLICY = 'B2C_PRIVACY_POLICY',
	B2C_RESERVATIONS_TERMS = 'B2C_RESERVATIONS_TERMS',
	B2C_PLACEHOLDER_HOMESCREEN = 'B2C_PLACEHOLDER_HOMESCREEN',
	B2C_NOTINO_RECEPTION_DASHBOARD = 'B2C_NOTINO_RECEPTION_DASHBOARD',
	B2C_NOTINO_RECEPTION_SALON_DETAIL = 'B2C_NOTINO_RECEPTION_SALON_DETAIL'
}

export const RESERVATION_BOOKING_MODAL_FIXED_HEADER_HEIGHT = 72 // in px

export const RESERVATION_BOOKING_MODAL_FIXED_FOOTER_HEIGHT = 92

export const RESERVATION_BOOKING_MODAL_LEFT_COL_WIDTH_DESKTOP = 420 // in px
export const RESERVATION_BOOKING_MODAL_RIGHT_COL_WIDTH_DESKTOP = 500 // in px
export const RESERVATION_BOOKING_MODAL_MAX_WIDTH_DESKTOP = RESERVATION_BOOKING_MODAL_LEFT_COL_WIDTH_DESKTOP + RESERVATION_BOOKING_MODAL_RIGHT_COL_WIDTH_DESKTOP // in px

export enum VALIDATION_MAX_LENGTH {
	LENGTH_1500 = 1500,
	LENGTH_500 = 500,
	LENGTH_255 = 255,
	LENGTH_160 = 160,
	LENGTH_20 = 20
}

export const SESSION_STORAGE_KEYS = {
	IS_SALONS_SEARCH: 'IS_SALONS_SEARCH'
}

export const LOCALE_STORAGE_KEYS = {
	DEVICE_ID: 'DEVICE_ID'
}

export enum PARTIAL_RATING {
	SERVICE = 'SERVICE',
	PLACE = 'PLACE',
	COMMUNICATION = 'COMMUNICATION',
	GENERAL_IMPRESSION = 'GENERAL_IMPRESSION'
}

export enum SCREEN_STATE_KEY {
	RESERVATION_SUMMARY_MODAL_SALON_CATEGORY_DETAIL = 'RESERVATION_SUMMARY_MODAL_SALON_CATEGORY_DETAIL'
}
export enum RESERVATION_STATE {
	PENDING = 'PENDING',
	APPROVED = 'APPROVED',
	DECLINED = 'DECLINED',
	CANCEL_BY_SALON = 'CANCEL_BY_SALON',
	CANCEL_BY_CUSTOMER = 'CANCEL_BY_CUSTOMER',
	CANCEL_BY_SYSTEM = 'CANCEL_BY_SYSTEM',
	REALIZED = 'REALIZED',
	NOT_REALIZED = 'NOT_REALIZED'
}

export enum SERVICE_TYPE {
	CUSTOM = 'CUSTOM',
	NORMAL = 'NORMAL',
	CUSTOM_GROUP = 'CUSTOM_GROUP'
}

export const RESERVATIONS_LIMIT_SALONS_PAGE = 25
export const FUTURE_RESERVATIONS_LIMIT_MY_RESERVATIONS_PAGE = 100
export const ACTIVE_PASSES_LIMIT_MY_PASSES_PAGE = 25
export const PAST_RESERVATIONS_LIMIT_MY_RESERVATIONS_PAGE = 12
export const PAST_PASSES_LIMIT_MY_PASSES_PAGE = 25

export enum TOKEN_AUD {
	REVIEW_RESERVATION = 'REVIEW_RESERVATION',
	CANCEL_RESERVATION = 'CANCEL_RESERVATION'
}

export const SALONS_PAGE_BANNER_SETTINGS = {
	DEFAULT_BACKGROUND_COLOR: '8695CA', // must be without '#', because <FullWidthBanner> component expects color without it
	DESKTOP_BANNER_WIDTH: 1035, // px
	DESKTOP_BANNER_HEIGHT: 340, // px
	MOBILE_BANNER_WIDTH: 768, // px
	MOBILE_BANNER_HEIGHT: 340 // px
}

export const GOOGLE_MAPS_URL = 'https://maps.google.com'

export enum MSG_TYPE {
	INFO = 'info',
	ERROR = 'error',
	SUCCESS = 'success'
	// WARNING = 'warning',
}

/*
We display salons in 3 or 2 or 1 column grid,
so we need number divisible by 3 a 2 in order to
avoid "missing" salons on the end of the grid -
base number is thus 12.
Update: we need to show banner at 4th place in grid,
that's why we need to fetch only 11 salons per page.
*/
export const SALONS_GRID_ELEMENTS_PER_PAGE = 12
const SALONS_BANNERS_ELEMENTS_PER_PAGE = 1
export const SALONS_PER_PAGE = SALONS_GRID_ELEMENTS_PER_PAGE - SALONS_BANNERS_ELEMENTS_PER_PAGE

export type ErrorMessage = {
	type: MSG_TYPE
	message: React.ReactNode
	path?: string
}

export const ABORT_KEYS = {
	AVAILABLE_SLOT_REQUEST_1_ABORT_KEY: 'AVAILABLE_SLOT_REQUEST_1_ABORT_KEY',
	AVAILABLE_SLOT_REQUEST_2_ABORT_KEY: 'AVAILABLE_SLOT_REQUEST_2_ABORT_KEY',
	FIRST_AVAILABLE_DATE_ABORT_KEY: 'FIRST_AVAILABLE_DATE_ABORT_KEY',
	SALONS_ABORT_KEY: 'SALONS_ABORT_KEY',
	SALONS_MAP_ABORT_KEY: 'SALONS_MAP_ABORT_KEY',
	SALONS_FILTER_COUNT_ABORT_KEY: 'SALONS_FILTER_COUNT_ABORT_KEY'
}

export enum PRODUCTION_ENVIRONMENT {
	PRODUCTION = 'production',
	UAT = 'uat',
	TEST = 'test',
	DEVELOPMENT = 'development',
	LOCAL = 'local',
	STAGING = 'staging'
}

export enum ERROR_PAGE_CODE {
	GENERAL_ERROR = 500,
	NOT_FOUND = 404,
	UNAUTHORIZED = 401,
	FORBIDDEN = 403
}

export const SALON_EMPLOYEES_LIMIT = 20

export enum RATING_ID {
	SALON_DETAIL_HEADER_DESKTOP = 'salon-detail-header-desktop',
	SALON_DETAIL_HEADER_MOBILE = 'salon-detail-header-mobile',
	SALON_DETAIL_PAGE_REVIEWS_DESKTOP_PREFIX = 'salon-detail-page-reviews-desktop',
	SALON_DETAIL_PAGE_REVIEWS_MOBILE_PREFIX = 'salon-detail-page-reviews-mobile',
	SALON_DETAIL_PAGE_REVIEWS_REVIEW_AVERAGE = 'salon-detail-page-reviews-review-average',
	SALON_DETAIL_PAGE_REVIEWS_RATING_LIST = 'salon-detail-page-reviews-rating-list',
	SALON_DETAIL_PAGE_REVIEWS_REVIEW = 'salon-detail-page-reviews-review',
	EXACT_RATING_OPTION = 'exact-rating-option'
}

export enum ORGANIZATION_ID {
	// STOODIO = 'stoodio',
	NOTINO = 'notino-partner'
}

export enum CART_RESERVATION_SUBMIT_ERROR_CODE {
	CART_IS_FULL = 'CART_IS_FULL',
	ALREADY_BOOKED = 'ALREADY_BOOKED',
	CART_EXPIRED = 'CART_EXPIRED'
}
